import React, { useState, useEffect } from 'react';

export default function StoreModal({ isOpen, onClose, onSave, initialData = null }) {
    const [englishName, setEnglishName] = useState('');
    const [arabicName, setArabicName] = useState('');
    const [logoFile, setLogoFile] = useState(null);

    // --- THE FIX IS HERE ---
    // This effect is now more robust and explicit about resetting the state.
    useEffect(() => {
        // This effect should only run when the modal is opened.
        if (isOpen) {
            if (initialData) {
                // We are in "Edit" mode, so fill the form.
                setEnglishName(initialData.english_name || '');
                setArabicName(initialData.arabic_name || '');
                setLogoFile(null); // Always start with a fresh file input
            } else {
                // We are in "Add" mode, so explicitly clear all fields.
                setEnglishName('');
                setArabicName('');
                setLogoFile(null);
            }
        }
    }, [initialData, isOpen]); // It depends on both isOpen and initialData

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setLogoFile(e.target.files[0]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // We await the onSave function to ensure it completes
            // before we try to close the modal.
            await onSave({ english_name: englishName, arabic_name: arabicName, logoFile });
            onClose(); // This now only runs AFTER the save is successful.
        } catch (error) {
            // The error message will be displayed on the main page.
            console.error("Failed to save store:", error);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6">{initialData ? 'Edit Store' : 'Add New Store'}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-700 font-medium mb-2">English Name</label>
                        <input type="text" value={englishName} onChange={(e) => setEnglishName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 font-medium mb-2">Arabic Name</label>
                        <input type="text" value={arabicName} onChange={(e) => setArabicName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 font-medium mb-2">Logo (Optional)</label>
                        <input type="file" onChange={handleFileChange} accept="image/*" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"/>
                    </div>
                    <div className="flex justify-end gap-4">
                        <button type="button" onClick={onClose} className="bg-gray-300 text-gray-800 font-bold py-2 px-6 rounded-lg hover:bg-gray-400">
                            Cancel
                        </button>
                        <button type="submit" className="bg-blue-600 text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-700">
                            Save Store
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}